import React from "react";
import { Link } from "react-router-dom";

export default function InternalLink({ link, children, ...props }) {
  const LinkParams= link + window?.location?.search 
  return (
                <Link
                  {...props}
                  to={LinkParams}
                >
                 {children}
                </Link>
  );
}
